export default "__VITE_ASSET__CA8MaVKv__"